/*eslint-disable*/
// chakra imports
import {
    Box,
    Button, Flex, Image,
    Link,
    Stack,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import IconBox from "components/Icons/IconBox";
import {CreativeTimLogo} from "components/Icons/Icons";
import logo from "assets/logo/logo.png";
import {Separator} from "components/Separator/Separator";
import {SidebarHelp} from "components/Sidebar/SidebarHelp";
import React from "react";
import {NavLink, useLocation} from "react-router-dom";
import {getLocalizedRouteName, useLanguage} from "contexts/LanguageContext";

// this function creates the links and collapses that appear in the sidebar (left menu)


const SidebarContent = ({logoText, routes}) => {
    const {language} = useLanguage();

    // to check for active links and opened collapses
    let location = useLocation();
    // this is for the rest of the collapses
    const [state, setState] = React.useState({});

    // verifies if routeName is the one active (in browser input)
    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };
    const createLinks = (routes) => {
        // Chakra Color Mode
        const activeBg = useColorModeValue("white", "gray.700");
        const inactiveBg = useColorModeValue("white", "gray.700");
        const activeColor = useColorModeValue("gray.700", "white");
        const inactiveColor = useColorModeValue("gray.400", "gray.400");

        return routes.map((prop, key) => {
            if (prop.redirect) {
                return null;
            }
            if (prop.category) {
                var st = {};
                st[prop["state"]] = !state[prop.state];
                return (
                    <div key={prop.name}>
                        <Text
                            color={activeColor}
                            fontWeight="bold"
                            mb={{
                                xl: "12px",
                            }}
                            mx="auto"
                            ps={{
                                sm: "10px",
                                xl: "16px",
                            }}
                            py="12px"
                        >
                            {getLocalizedRouteName(prop, language)}
                        </Text>
                        {createLinks(prop.views)}
                    </div>
                );
            }
            return (
                <NavLink to={prop.layout + prop.path} key={prop.name}>
                    {activeRoute(prop.layout + prop.path) === "active" ? (
                        <Button
                            boxSize="initial"
                            justifyContent="flex-start"
                            alignItems="center"
                            bg={activeBg}
                            mb={{
                                xl: "12px",
                            }}
                            mx={{
                                xl: "auto",
                            }}
                            ps={{
                                sm: "10px",
                                xl: "16px",
                            }}
                            py="12px"
                            borderRadius="15px"
                            _hover="none"
                            w="100%"
                            _active={{
                                bg: "inherit",
                                transform: "none",
                                borderColor: "transparent",
                            }}
                            _focus={{
                                boxShadow: "none",
                            }}
                        >
                            <Flex>
                                {typeof prop.icon === "string" ? (
                                    <Icon>{prop.icon}</Icon>
                                ) : (
                                    <IconBox
                                        bg="teal.300"
                                        color="white"
                                        h="30px"
                                        w="30px"
                                        me="12px"
                                    >
                                        {prop.icon}
                                    </IconBox>
                                )}
                                <Text color={activeColor} my="auto" fontSize="sm">
                                    {getLocalizedRouteName(prop, language)}
                                </Text>
                            </Flex>
                        </Button>
                    ) : (
                        <Button
                            boxSize="initial"
                            justifyContent="flex-start"
                            alignItems="center"
                            bg="transparent"
                            mb={{
                                xl: "12px",
                            }}
                            mx={{
                                xl: "auto",
                            }}
                            py="12px"
                            ps={{
                                sm: "10px",
                                xl: "16px",
                            }}
                            borderRadius="15px"
                            _hover="none"
                            w="100%"
                            _active={{
                                bg: "inherit",
                                transform: "none",
                                borderColor: "transparent",
                            }}
                            _focus={{
                                boxShadow: "none",
                            }}
                        >
                            <Flex>
                                {typeof prop.icon === "string" ? (
                                    <Icon>{prop.icon}</Icon>
                                ) : (
                                    <IconBox
                                        bg={inactiveBg}
                                        color="teal.300"
                                        h="30px"
                                        w="30px"
                                        me="12px"
                                    >
                                        {prop.icon}
                                    </IconBox>
                                )}
                                <Text color={inactiveColor} my="auto" fontSize="sm">
                                    {getLocalizedRouteName(prop, language)}
                                </Text>
                            </Flex>
                        </Button>
                    )}
                </NavLink>
            );
        });
    };

    const links = <>{createLinks(routes)}</>;

    return (
        <>
            <Box pt={"25px"} mb="12px">
                {/* Interactive brand lockup: logo + "Digital Ghanti" wordmark.
                    School name/address now live in the top-right navbar, so the
                    sidebar shows only the logo and the app label. */}
                <Link
                    href={`${process.env.PUBLIC_URL}/#/`}
                    target="_blank"
                    display="flex"
                    lineHeight="100%"
                    mb="30px"
                    fontWeight="bold"
                    justifyContent="center"
                    alignItems="center"
                    role="group"
                    borderRadius="16px"
                    py="10px"
                    transition="all 0.25s ease"
                    _hover={{bg: useColorModeValue("teal.50", "whiteAlpha.100"), transform: "translateY(-2px)"}}
                    _focusVisible={{boxShadow: "outline", outline: "none"}}
                >
                    {/*<CreativeTimLogo w="32px" h="32px" me="10px" />*/}
                    <Image
                        src={logo}
                        w="72px"
                        h="72px"
                        me="12px"
                        transition="transform 0.35s ease"
                        _groupHover={{transform: "rotate(-8deg) scale(1.06)"}}
                    />
                    <Flex direction="column" align="flex-start" lineHeight="1.1">
                        <Text
                            fontSize="lg"
                            fontWeight="extrabold"
                            bgGradient="linear(to-r, teal.400, blue.500)"
                            bgClip="text"
                            letterSpacing="tight"
                        >
                            Digital Ghanti
                        </Text>
                        <Text
                            fontSize="xs"
                            fontWeight="semibold"
                            color={useColorModeValue("gray.500", "gray.400")}
                            transition="color 0.25s ease"
                            _groupHover={{color: "teal.400"}}
                        >
                            स्वचालित घण्टी
                        </Text>
                    </Flex>
                </Link>
                <Separator></Separator>
                {/*<div>*/}
                {/*    <Box bg="red" w="100%" p="1" color="white">*/}
                {/*        तपाईं सफ्टवेयरको परीक्षण चरणमा हुनुहुन्छ।*/}
                {/*    </Box>*/}
                {/*</div>*/}

            </Box>
            <Stack direction="column" mb="40px">
                <Box>{links}</Box>
            </Stack>
            <SidebarHelp/>
        </>
    )
}

export default SidebarContent
